import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import ConfirmSetStartPopupDetails from './ConfirmSetStartPopupDetails.vue'

export const ConfirmSetStartPopup = new PopupBuilder('Confirm set start')
  .appendBody(ConfirmSetStartPopupDetails)
  .build()
